import {
  RETRIEVE_REFUNDS,
  RETRIEVE_REFUND_VIEW,
} from "../actions/types";

const initialState = { refunds: [], totalRefundCount: 0 };

const refundReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case RETRIEVE_REFUNDS:
      return {
        refunds: payload.rows,
        totalRefundCount: payload.count,
      };

    case RETRIEVE_REFUND_VIEW:
      return payload;

    default:
      return state;
  }
};

export default refundReducer;